import { stateToHTML } from 'draft-js-export-html';
import { convertFromHTML, ContentState, convertToRaw } from 'draft-js';

export const htmlToDraft = (html = '') => {
  if (!html) {
    return '';
  }

  const content = convertFromHTML(html);
  const state = ContentState.createFromBlockArray(content.contentBlocks, content.entityMap);

  return JSON.stringify(convertToRaw(state));
};

export const draftToHtml = (contentState) => {
  return stateToHTML(contentState);
};
